import React from "react";

const month = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};

export const movieDate = arg => {
  let date = new Date(arg);

  // date = new Date(date.getTime() - date.getTimezoneOffset()*60000)
  // console.log(date.toISOString())

  return (
    <span>
      <strong>{date.getDate()}</strong> {month[date.getMonth()]}{" "}
      <strong>'{date.getFullYear()}</strong>
    </span>
  );
};
